import store from "../store";
import globalNewCar from "@/helpers/globalNewCar";
import func from "@/helpers/func";
import getDataFromUrl from "@/helpers/getDataFromUrl";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    computed: {
        ...mapGetters({
            lib: "LIB"
        }),
        convertCars() {
            let cars = []
            for (const key in this.carsInSliders) {
                if (this.carsInSliders.hasOwnProperty(key)) {
                    let carsItem = this.carsInSliders[key].cars.map(el => {
                        // const model = el.m.split(' ')
                        if(el.ad){
                            return el;
                        }

                        return this.convertCar(el);
                    })

                    cars[key] = {
                        cars: carsItem,
                        title: this.carsInSliders[key].title,
                        fuel_id: this.carsInSliders[key].fuel_id
                    }
                }
            }
            return cars
        },
    },
    methods: {
        ...mapActions([
            "GET_LIB"
        ]),
        ...mapMutations([
            'setLastCarPageVisit'
        ]),
        convertCar(el) {
            let imageUrl = store.state.imageUrl;


            const fuel = this.lib && this.lib.fuel_type && this.lib.fuel_type.find(e => e.id == el.ft)
            const fuel2 = this.lib && this.lib.fuel_type && this.lib.fuel_type.find(e => e.id == el.ft2)

            return {
                id: el.car_id,
                big_photo: "",
                brand: el.b,
                co: "",
                company_name: "",
                consumption: "",
                discount: el.old_price > 0 ? el.v * 1000 : false,//el.verdtilbod == 1 && el.old_price > 0 ? el.v * 1000 : false,
                drif: "text",
                fuel: fuel ? fuel.name : '',// el.fuel_type || "",
                fuel2: fuel2 ? fuel2.name : '',//fuel2.name || "",
                model_class: '',
                model_name: el.m,
                price: el.v > 0 ? parseFloat(el.old_price > 0 ? el.old_price : el.v) * 1000 : 0,//el.verdtilbod == 1 &&
                price_hide: "0",
                thumbnail: el.main_img
                    // ? `${imageUrl}/img/cars/${el.car_id}/${el.main_img}.jpg`
                    // ? `${imageUrl}/images/${el.main_img}.webp`
                    ? globalNewCar.getPicUrl(el.main_img)
                    : `${imageUrl}/img/main-thumb.png`,
                transition_id: el.g,
                transition: this.$store.state.lib && this.$store.state.lib.girartegund &&
                    this.$store.state.lib.girartegund[el.g] && this.$store.state.lib.girartegund[el.g].name,
                mileage: el.e ? parseInt(el.e).format() : "",
                year: el.a || "",
                registrationMounth: el.sk || "",
                isOldCars: true,
                fav: Number(el.fav),
                del: el.del,
                transmision_id: el.g,
                is_special_price: el.is_special_price > 0? parseInt(el.is_special_price):0,
                is_price_changing: el.is_price_changing > 0? parseInt(el.is_price_changing):0,
                parking: Number(el.spot),
                withoutVat: el.vsk == 1 ? true : false,
                fuel3: el.fuel3
            }
        },
        getParams(d) {
            if (window.location.search.slice(1)) {
                const res = getDataFromUrl();
                for (let k in res) {
                    d[k] = res[k];
                }
                /*
                                window.location.search.slice(1).split("&").map(e => {
                                    let pa = e.split("=");
                                    d[pa[0]] = pa[1].split(",");
                                })
                 */
            }
        },
        resetFilter(filters) {
            let max_filters = this.$store.state.moduleOldCars.startParams;
            if (filters) {
                for (var k in filters) {
                    if (k != "argerd" && k != "verd" && k != "ekinn") {
                        if (filters[k].length > 0) {
                            filters[k] = [];
                            // console.log(k);
                        }
                    }
                }

                filters.verd = [max_filters.verd.min, max_filters.verd.max];
                filters.argerd = [max_filters.argerd.min, max_filters.argerd.max];
                filters.ekinn = [max_filters.ekinn.min, max_filters.ekinn.max];
                filters.verdtilbod = false;
                filters.parking = false;
                filters.notInCountry = false;
            }
        },
        setUrl() {
            let params = this.cleanFilters(this.filters);
            if (Object.keys(params).indexOf('verd') >= 0 && params.verd[1] === '20000000+') {
                params.verd[1] = 20000000;
            }

            if(params.k7){
                delete params.k7;
            }

            console.log("params",params);
            let url = this.convertParamToUrl(params);

            if(this.issetUserFriendlyParams){
                if(url.includes("?")){
                    const curController = this.$router.resolve({name: this.$route.name});
                    url = curController.href + url;
                }
                //this.$router.push({name:this.$route.name});
            }

            if (this.$route.fullPath.replace("/notadir-bilar", "") !== url.replace("%2C", ",")) {
                this.$router.push(url).catch(e => console.log("Index"));
            }
        },
        cleanFilters(f) {
            return func.cleanFilters(f);
        },
        /*cleanFilters(f) {
            let res = {};
            let max_filters = this.$store.state.moduleOldCars.startParams;

            for (let k in f) {
                if(store.state.excludeFilterParams.includes(k)){
                    continue;
                }
                let item = f[k];
                if (k == "argerd") {
                    if (
                        item[0] == max_filters.argerd.min &&
                        item[1] == max_filters.argerd.max
                    ) {
                        continue;
                    }
                }

                if (k == "ekinn") {
                    if (
                        item[0] == max_filters.ekinn.min &&
                        item[1] == max_filters.ekinn.max
                    ) {
                        continue;
                    }
                }

                if (k == "verd") {
                    if (item[0] == max_filters.verd.min && parseInt(item[1]) == max_filters.verd.max) {
                        continue;
                    }
                }

                if (k == "affinity") {
                    if (item[0] == max_filters.affinity.min && parseInt(item[1]) == max_filters.affinity.max) {
                        continue;
                    }
                }

                if (k == "towing_capacity") {
                    if (item[0] == max_filters.towing_capacity.min && parseInt(item[1]) == max_filters.towing_capacity.max) {
                        continue;
                    }
                }

                if (k == "verdtilbod" && item) {
                    res[k] = item;
                    continue;
                }

                if (k == "notInCountry" && item) {
                    res[k] = item;
                    continue;
                }

                if (k == "k7" && item) {
                    res[k] = item;
                    continue;
                }

                if (k == "parking" && item) {
                    res[k] = item;
                    continue;
                }

                if (item.length > 0) {
                    if (["argerd", "ekinn", "verd", "affinity", "towing_capacity"].indexOf(k) >= 0) {
                        res[k] = item;
                    } else {
                        res[k] = item.slice(0).sort();
                    }
                }
            }

            return res;
        },*/
        convertParamToUrl(params) {
            let url = "?" + new URLSearchParams(params).toString()
            return url;
        },
        findInArr(arr, id, e, key) {
            key = key || 'id';
            for (var k in arr) {
                var item = arr[k];
                if (item[key] == id) {
                    if (e) {
                        return item;
                    }
                    return k;
                }
            }
            return false;
        },
        getBrandsModel(bm) {
            var res = {};
            for (var k in bm) {
                for (var kk in bm[k]) {
                    res[kk] = bm[k][kk];
                }
            }
            return res;
        },
        addFilersName() {
            return func.addFilersName(this.cleanFilters(this.filters), this.lib)
            //return this._addFilersName(this.cleanFilters(this.filters), this.oldCars);
        },
        formatArr(arr) {
            let res = [];
            for (var k in arr) {
                for (var kk in arr[k]) {
                    res.push(arr[k][kk]);
                }
            }
            return res;
        },
        loadUrlParams(){
            const urlBrand = this.getUrlName(this.getUrlBrand);
            if (urlBrand && this.lib && this.lib.brands) {
                let findModel = null;
                if(this.getUrlModel){
                    const getUrlModel = this.getUrlName(this.getUrlModel);
                    findModel =  this.lib.old_cars_models.find(e => e.name && this.getUrlName(e.name) === getUrlModel);
                }
                let findBrand = this.lib.brands.find(e => this.getUrlName(e.name) === urlBrand);
                if(findBrand){
                    this.filters.brands = [findBrand.id];
                }else{
                    this.$router.push('/notadir-bilar/not-found');
                }

                if(findModel){
                    this.filters.brand_model = [findModel.id];
                }
                this.$store.state.carFilter = this.cleanFilters(this.filters);
                this.post(true);
            } else {
                this.getParams(this.filters);
            }
        }
    }
}